export default __webpack_public_path__ + "static/media/prod1.e9bc0221.png";